<div [translate] class="login-container">
    <div id="content" class="login-box">
        <div class="l-align-x login-panel">
            <spinner *ngIf="loadingNewPage"></spinner>
        </div>
    </div>
</div>
<router-outlet></router-outlet>
